(function () {

  'use strict';

  /*
   * Fixed dimension range
   *
   * 1'  = 12"
   * 14' = 168"
   */
  const MIN_INCH = 12;
  const MAX_INCH = 168;


  /*
   * Preserve selected values during
   * Pipeline AJAX re-render.
   */
  const dimensionState = {};


  function initCustomDimensionFilters(container) {

    if (!container) return;


    const filter = container.querySelector('.dimension-filter');

    if (!filter) return;


    /*
     * Prevent duplicate initialization.
     */
    if (filter.dataset.dimensionInitialized === 'true') {
      return;
    }

    filter.dataset.dimensionInitialized = 'true';


    const boxes = filter.querySelectorAll(
      '.dimension-box[data-dimension-type]'
    );

    if (!boxes.length) return;


    /*
     * ---------------------------------------------------------
     * SCOPE FOR NATIVE CHECKBOXES
     * ---------------------------------------------------------
     *
     * The native Shopify checkboxes (.js-dimension-filter) live
     * OUTSIDE .dimension-filter (they come from the theme's own
     * filter accordion loop, not from our custom markup).
     *
     * So we must search inside the closest <form> that wraps
     * BOTH our slider AND the native checkboxes. If no <form>
     * is found (edge case), fall back to the whole document.
     */

    const scopeRoot =
      filter.closest('form') || document;


    /*
     * ---------------------------------------------------------
     * Functions that must run BEFORE Apply reads the state,
     * to force-commit whatever the user was mid-typing (in
     * case they click Apply without blurring an input first).
     * One entry per box, pushed below.
     * ---------------------------------------------------------
     */

    const pendingCommits = [];


    /*
     * ---------------------------------------------------------
     * COMMON HELPERS
     * ---------------------------------------------------------
     */

    function toInches(feet, inches) {

      let ft = parseInt(feet, 10);
      let inch = parseInt(inches, 10);

      if (!Number.isFinite(ft)) {
        ft = 0;
      }

      if (!Number.isFinite(inch)) {
        inch = 0;
      }

      ft = Math.max(0, ft);
      inch = Math.max(0, Math.min(11, inch));

      return (ft * 12) + inch;
    }


    function fromInches(value) {

      value = Number(value);

      if (!Number.isFinite(value)) {
        value = MIN_INCH;
      }

      value = Math.max(
        MIN_INCH,
        Math.min(MAX_INCH, value)
      );

      return {
        feet: Math.floor(value / 12),
        inches: value % 12
      };
    }


    /*
     * ---------------------------------------------------------
     * INITIALIZE EACH DIMENSION (single pass — setup + UI)
     * ---------------------------------------------------------
     */

    boxes.forEach(function (box) {

      const type =
        box.dataset.dimensionType || '';


      const typeKey =
        type.toLowerCase().includes('width')
          ? 'width'
          : type.toLowerCase().includes('length')
            ? 'length'
            : '';


      if (!typeKey) return;


      /*
       * Sliders
       */

      const minSlider =
        box.querySelector('.dimension-range-min');

      const maxSlider =
        box.querySelector('.dimension-range-max');

      const selectedRange =
        box.querySelector('.dimension-range-selected');


      /*
       * Inputs
       */

      const minFeet =
        box.querySelector('[data-input="min-feet"]');

      const minInches =
        box.querySelector('[data-input="min-inches"]');

      const maxFeet =
        box.querySelector('[data-input="max-feet"]');

      const maxInches =
        box.querySelector('[data-input="max-inches"]');


      if (
        !minSlider ||
        !maxSlider ||
        !selectedRange ||
        !minFeet ||
        !minInches ||
        !maxFeet ||
        !maxInches
      ) {
        return;
      }


      /*
       * -------------------------------------------------------
       * STATE
       * -------------------------------------------------------
       *
       * Initial range is always full range (12" -> 168").
       * We never read rendered checkbox state to seed this,
       * so by default nothing looks "applied".
       */

      if (!dimensionState[typeKey]) {

        dimensionState[typeKey] = {
          min: MIN_INCH,
          max: MAX_INCH
        };

      }


      const state =
        dimensionState[typeKey];


      minSlider.min = MIN_INCH;
      minSlider.max = MAX_INCH;
      minSlider.step = 1;

      maxSlider.min = MIN_INCH;
      maxSlider.max = MAX_INCH;
      maxSlider.step = 1;


      function updateInputs() {

        const min = fromInches(state.min);
        const max = fromInches(state.max);

        minFeet.value = min.feet;
        minInches.value = min.inches;
        maxFeet.value = max.feet;
        maxInches.value = max.inches;

      }


      function updateSliders() {

        minSlider.value = state.min;
        maxSlider.value = state.max;

      }


      function updateSelectedRange() {

        const total = MAX_INCH - MIN_INCH;

        const minPercent =
          ((state.min - MIN_INCH) / total) * 100;

        const maxPercent =
          ((state.max - MIN_INCH) / total) * 100;

        selectedRange.style.left = minPercent + '%';
        selectedRange.style.right = (100 - maxPercent) + '%';

      }


      /*
       * This function NEVER touches checkboxes.
       * Checkboxes are only touched on Apply click.
       */

      function updateUI() {

        updateInputs();
        updateSliders();
        updateSelectedRange();

      }


      /*
       * -------------------------------------------------------
       * MIN SLIDER
       * -------------------------------------------------------
       */

      minSlider.addEventListener('input', function () {

        let value = Number(minSlider.value);

        if (!Number.isFinite(value)) {
          value = MIN_INCH;
        }

        value = Math.max(MIN_INCH, Math.min(MAX_INCH, value));

        if (value > state.max) {
          value = state.max;
        }

        state.min = value;

        updateUI();

      });


      /*
       * -------------------------------------------------------
       * MAX SLIDER
       * -------------------------------------------------------
       */

      maxSlider.addEventListener('input', function () {

        let value = Number(maxSlider.value);

        if (!Number.isFinite(value)) {
          value = MAX_INCH;
        }

        value = Math.max(MIN_INCH, Math.min(MAX_INCH, value));

        if (value < state.min) {
          value = state.min;
        }

        state.max = value;

        updateUI();

      });


      /*
       * -------------------------------------------------------
       * MANUAL INPUT (feet / inches boxes)
       * -------------------------------------------------------
       *
       * Two-phase handling:
       *
       * 1) LIVE (on every keystroke, 'input' event):
       *    Only move the slider thumbs + highlighted bar so
       *    typing still feels "synced". We deliberately do
       *    NOT rewrite any of the 4 text fields here, and we
       *    do NOT force min/max to stop crossing — otherwise
       *    typing something like "11" into max while min=5
       *    gets clobbered back to "5" after the first digit,
       *    making it impossible to finish typing.
       *
       * 2) COMMIT (on 'blur', i.e. focus leaves the field, or
       *    when Apply is clicked): NOW we clamp to 1'-14' and
       *    fix any min > max crossing, then sync everything
       *    (fields + slider + bar) via updateUI().
       */

      let lastEditedSide = 'min';


      function liveUpdateFromInputs(side) {

        lastEditedSide = side;

        const rawMin = toInches(minFeet.value, minInches.value);
        const rawMax = toInches(maxFeet.value, maxInches.value);

        state.min = Math.max(MIN_INCH, Math.min(MAX_INCH, rawMin));
        state.max = Math.max(MIN_INCH, Math.min(MAX_INCH, rawMax));

        updateSliders();
        updateSelectedRange();

      }


      function commitInputs() {

        let min = toInches(minFeet.value, minInches.value);
        let max = toInches(maxFeet.value, maxInches.value);

        min = Math.max(MIN_INCH, Math.min(MAX_INCH, min));
        max = Math.max(MIN_INCH, Math.min(MAX_INCH, max));

        if (min > max) {

          if (lastEditedSide === 'min') {
            min = max;
          } else {
            max = min;
          }

        }

        state.min = min;
        state.max = max;

        updateUI();

      }


      pendingCommits.push(commitInputs);


      minFeet.addEventListener('input', function () {
        liveUpdateFromInputs('min');
      });


      minInches.addEventListener('input', function () {
        liveUpdateFromInputs('min');
      });


      maxFeet.addEventListener('input', function () {
        liveUpdateFromInputs('max');
      });


      maxInches.addEventListener('input', function () {
        liveUpdateFromInputs('max');
      });


      [minFeet, minInches, maxFeet, maxInches].forEach(function (el) {
        el.addEventListener('blur', commitInputs);
      });


      /*
       * -------------------------------------------------------
       * STOP PROPAGATION TO THE FORM
       * -------------------------------------------------------
       *
       * Sliders and manual inputs must only update our own UI
       * state. They must NEVER let their native 'input' /
       * 'change' event bubble up to the <form>, otherwise the
       * theme's own delegated filter listener (which reacts to
       * ANY input/change inside the form) would auto-apply the
       * filter on every drag / keystroke instead of waiting for
       * the Apply button.
       *
       * These listeners are added AFTER the state-update
       * listeners above, so our internal state/UI logic always
       * runs first — this call only blocks further bubbling,
       * it does not affect listeners already bound directly on
       * these same elements.
       */

      const dimensionControls = [
        minFeet,
        minInches,
        maxFeet,
        maxInches,
        minSlider,
        maxSlider
      ];

      dimensionControls.forEach(function (input) {

        input.addEventListener(
          'input',
          function (event) {
            event.stopPropagation();
          }
        );

        input.addEventListener(
          'change',
          function (event) {
            event.stopPropagation();
          }
        );

      });


      /*
       * -------------------------------------------------------
       * INITIAL UI (no checkbox touching here)
       * -------------------------------------------------------
       */

      updateUI();

    });


    /*
     * ---------------------------------------------------------
     * SINGLE APPLY BUTTON
     * ---------------------------------------------------------
     */

    const applyButton = filter.querySelector('.dimension-apply');

    if (!applyButton) return;


    applyButton.addEventListener('click', function (event) {

      event.preventDefault();


      /*
       * -----------------------------------------------------
       * FORCE-COMMIT ANY IN-PROGRESS TYPING
       * -----------------------------------------------------
       *
       * If the user was still focused on a feet/inches field
       * and clicks Apply directly (without blurring first),
       * make sure validation/clamping still runs before we
       * read state.min / state.max for the checkboxes below.
       */

      pendingCommits.forEach(function (commit) {
        commit();
      });


      /*
       * Track every checkbox whose checked state actually
       * changed, so we only dispatch events on those
       * (avoids unnecessary noise / re-renders).
       */

      const changedCheckboxes = [];


      boxes.forEach(function (box) {

        const type = box.dataset.dimensionType || '';

        const typeKey =
          type.toLowerCase().includes('width')
            ? 'width'
            : type.toLowerCase().includes('length')
              ? 'length'
              : '';

        if (!typeKey) return;

        const state = dimensionState[typeKey];


        /*
         * Search scopeRoot (closest form / document),
         * NOT inside .dimension-filter, since the native
         * checkboxes live outside our custom markup.
         */

        const checkboxes = Array.from(
          scopeRoot.querySelectorAll('.js-dimension-filter')
        ).filter(function (checkbox) {
          return checkbox.dataset.dimensionType === type;
        });


        checkboxes.forEach(function (checkbox) {

          const value = Number(checkbox.dataset.dimensionValue);

          if (!Number.isFinite(value)) {
            return;
          }

          const shouldBeChecked =
            value >= state.min && value <= state.max;

          if (checkbox.checked !== shouldBeChecked) {

            checkbox.checked = shouldBeChecked;

            changedCheckboxes.push(checkbox);

          }

        });

      });


      /*
       * ---------------------------------------------------------
       * DISPATCH EVENTS — ONLY ON APPLY
       * ---------------------------------------------------------
       *
       * Setting .checked directly does NOT fire native events.
       * We dispatch both 'input' and 'change' (bubbling) on
       * EVERY checkbox that changed, so this works whether the
       * theme listens at the form level (delegation) or attaches
       * listeners directly on each checkbox. These events are
       * dispatched on the CHECKBOXES (not our sliders), so they
       * are unaffected by the stopPropagation guards above and
       * will correctly reach the theme's filter logic.
       */

      if (changedCheckboxes.length) {

        changedCheckboxes.forEach(function (checkbox) {

          checkbox.dispatchEvent(
            new Event('input', { bubbles: true })
          );

          checkbox.dispatchEvent(
            new Event('change', { bubbles: true })
          );

        });

      } else {

        /*
         * Nothing changed (e.g. user clicked Apply without
         * touching sliders) — still nudge the form once so
         * behaviour stays predictable if needed. Safe to
         * remove this else-block if not required.
         */

        const anyCheckbox =
          scopeRoot.querySelector('.js-dimension-filter');

        if (anyCheckbox) {

          anyCheckbox.dispatchEvent(
            new Event('change', { bubbles: true })
          );

        }

      }

    });

  }


  /*
   * -----------------------------------------------------------
   * GLOBAL FUNCTION
   * -----------------------------------------------------------
   *
   * IMPORTANT: call this again after every AJAX facet
   * re-render (Shopify replaces the filter section HTML,
   * including our custom slider markup, with fresh Liquid
   * output). Hook this into your theme's facets.js at the
   * point where it swaps in new filter HTML, e.g.:
   *
   *   document.querySelector('#facets').innerHTML = newHTML;
   *   window.initCustomDimensionFilters(document.querySelector('#facets'));
   */

  window.initCustomDimensionFilters = initCustomDimensionFilters;


  /*
   * -----------------------------------------------------------
   * INITIAL PAGE LOAD
   * -----------------------------------------------------------
   */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCustomDimensionFilters(document);
    });
  } else {
    initCustomDimensionFilters(document);
  }

})();